import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, Subject, switchMap, throwError } from 'rxjs';
import { AuthService, LocalService } from '../services';
import { inject } from '@angular/core';
import { EventData } from '../shared/classes/EventData';
import { EventBusService } from '../services/event-bus.service';


export const httpRequestInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const localService = inject(LocalService);
  const authService = inject(AuthService);
  const eventBusService = inject(EventBusService);

  const withCredentials = !req.url.includes('https://api.ipify.org/?format=json');

  req = req.clone({
    withCredentials: withCredentials,
  });

  return next(req).pipe(
    catchError((error) => {
      if (
        error instanceof HttpErrorResponse &&
        !req.url.includes('auth/authenticate') &&
        error.status === 401
      ) {
        return handle401Error(req, next, localService, authService, eventBusService);
      }

      return throwError(() => error);
    })
  );
};

let isRefreshing = false;
//this is to queue the other requests while the token is being refreshed, 
//there are cases where the interceptor is called multiple times before the token is refreshed.
let refreshTokenSubject: Subject<boolean> = new Subject<boolean>();

const handle401Error = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
  localService: LocalService,
  authService: AuthService,
  eventBusService: EventBusService
): Observable<HttpEvent<any>> => {
  if (!isRefreshing) {
    isRefreshing = true;
    refreshTokenSubject = new Subject<boolean>();

    if (localService.isLoggedIn) {
      return authService.refreshToken().pipe(
        switchMap(() => {
          isRefreshing = false;
          //refresh worked, so we can retry the request
          refreshTokenSubject.next(true);
          refreshTokenSubject.complete();
          return next(request.clone({ withCredentials: true }));
        }),
        catchError((error) => {
          isRefreshing = false;
          refreshTokenSubject.error(error);
          if (error.status == '403') {
            eventBusService.emit(new EventData('logout', null));
            refreshTokenSubject.complete();
          }
          return throwError(() => error);
        })
      );
    }
  }

    // Queue the request and wait for the token refresh to complete
    return refreshTokenSubject.pipe(
      switchMap(() => next(request)),
      catchError((error) => throwError(() => error))
    );
};
